<template>
  <svg
    width="1875"
    height="1055"
    viewBox="0 0 1875 1055"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1521_20374)">
      <g clip-path="url(#clip1_1521_20374)">
        <path
          d="M1621.56 692.97L1605.44 676.074L1525.99 632.703L1400.37 564.447L1389.13 550.829L1363.29 531.929L1243.56 458.187L1174.52 419.844L1137.32 399.18L1020.3 334.196L1004.64 331.351L988.981 323.354L979.228 306.169L975.756 304.471L971.843 304.807L966.56 307.721L962.594 307.434L959.676 305.799L892.977 272.264L849.464 252.987L849.683 253.111L813.684 232.639L793.433 218.489L777.628 204.668L763.292 187.029L751.294 168.784H751.292L746.215 161.755L737.7 149.964L716.635 136.019L691.268 127.386L661.755 124.772L635.065 127.417L611.3 136.048L592 148.221L580.705 161.795L577.318 165.864L567.245 186.331L562.032 211.965L557.096 271.466L553.235 295.279L546.116 313.726L534.72 330.732L521.333 341.971L506.791 348.963L491.387 351.929L490.586 351.921L478.602 351.78L442.546 351.363L418.801 347.972L398.878 340.86L342.938 317.218L321.715 315.118L312.683 316.154L302.952 317.273L285.085 325.149L268.64 338.603L252.955 359.222L249.65 379.891L252.059 402.684L265.143 424.68L292.936 452.508L305.918 469.57L311.026 485.171L310.077 502.938L305.053 520.111L289.64 570.825L285.868 595.411L288.52 619.903L295.777 642.596L306.664 659.833L312.683 664.69L326.705 676.01L347.812 684.861L368.23 688.094L453.702 686.572L481.124 683.456L508.753 676.787L527.627 668.033L544.439 654.245L557.766 631.212L570.076 585.327L587.739 491.948L626.573 280.091L634.471 245.201L639.444 237.503L647.53 232.915L653.63 231.711L662.513 233.425L673.463 240.53L747.323 429.423L762.417 457.822L773.519 475.799L786.9 491.425L811.145 514.837L856.248 544.13L937.553 582.726L963.932 595.096L983.067 609.018L996.87 626.416L1005.11 648.166L1005.73 666.226L999.319 686.166L990.685 703.265L973.912 716.294L941.405 735.63L854.083 773.135L828.885 784.52L802.759 814.852L781.681 857.837L782.61 875.7L794.133 891.844L804.499 895.989L815.527 900.399L835.103 896.062L835.206 895.989L854.796 882.293L894.774 838.18L904.561 831.886L929.759 822.376L956.557 820.805L982.328 825.133L1004.17 832.256L1013.45 841.414L1043.27 892.621L1045.58 895.989L1063.16 921.663L1077.92 934.067L1097.91 939.883L1119.42 940.921L1160.81 934.258L1190.66 929.454L1326.97 900.381L1344.55 895.989L1432.84 873.928L1470.47 861.152L1500.18 847.441L1526.04 828.718L1532.49 824.047L1591.36 770.412L1620.57 728.742L1629.43 708.689L1621.56 692.97ZM962.937 313.049L967.998 313.698L972.625 311.105L981.942 324.896L983.629 327.21L1000.63 336.834L1015.8 341.353L1348.97 534.484L1348.91 534.378L1353.52 536.784L1306.14 512.692L1160.81 430.047L901.245 282.434L962.937 313.049ZM1600.75 720.924L1573.69 759.517L1526.03 802.942L1517.22 810.968L1487.62 832.404L1461.06 844.659L1425.54 856.715L1321.13 882.811L1259.33 895.989L1185.97 911.635L1160.81 915.683L1117.96 922.583L1102.21 921.821L1089.86 918.229L1080.69 910.527L1070.74 895.989L1062.59 884.094L1031.9 831.39L1017.27 816.949L988.508 807.572L957.962 802.439L924.319 804.415L893.258 816.139L879.129 825.221L838.878 869.638L824.811 879.471L817.702 881.047L809.519 877.776L804.193 870.317L803.709 861.037L821.984 823.768L843.693 798.567L864.182 789.308L952.769 751.257L987.764 730.442L1008.99 713.959L1020.03 692.085L1027.65 668.377L1026.85 645.097L1016.77 618.47L999.644 596.893L976.599 580.121L948.811 567.092L868.404 528.924L826.265 501.558L804.09 480.138L792.194 466.253L782.13 449.958L767.738 422.875L693.428 232.832L681.228 221.384L667.608 215.691L653.573 212.978L638.584 215.944L622.753 224.928L613.64 239.032L605.036 277.068L566.123 489.358L548.618 581.893L537.011 625.162L526.419 643.467L514.453 653.277L500.306 659.842L476.602 665.564L451.94 668.364L370.05 669.825L354.903 667.425L339.484 660.957L324.358 648.756L316.245 635.911L312.683 624.774L310.102 616.703L307.835 595.744L311.131 574.261L312.683 569.153L326.304 524.331L331.799 505.528L332.998 483.126L326.12 462.12L312.683 444.459L310.605 441.728L283.552 414.644L273.454 397.66L271.622 380.302L273.972 365.602L285.71 350.174L298.101 340.033L309.745 334.9L312.683 334.565L321.913 333.505L336.538 334.953L389.63 357.389L412.603 365.589L440.54 369.579L477.889 370.01L489.875 370.147L489.873 370.149L493.702 370.194L514.877 366.119L534.768 356.552L552.309 341.831L566.245 321.043L574.619 299.334L578.833 273.34L583.744 214.139L588.369 191.394L596.616 174.633L607.304 161.788L607.944 161.018L622.399 151.903L640.817 145.214L661.904 143.128L685.88 145.248L705.52 151.931L720.369 161.761L721.037 162.204L722.5 164.228L735.373 182.464L744.637 196.55L760.563 216.15L778.501 231.832L800.487 247.192L1160.81 452.105L1294.06 527.881L1526 654.493L1590.55 689.732L1602.58 702.347L1605.97 709.106L1600.75 720.924Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M516.6 133.106L526.128 136.514L519.314 148.538L510.467 144.539L516.6 133.106V133.106Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M594.784 51.1885L594.856 51.4138L595.698 51.1885"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M738.472 82.2506L752.775 87.9671L756.847 81.1242L742.571 74.8164L738.472 82.2506V82.2506Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M814.719 63.4118L824.925 73.127L832.417 67.4105L821.532 57.6953L814.719 63.4118V63.4118Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M831.06 79.406L841.266 89.1213L848.756 83.4048L837.873 73.6895L831.06 79.406V79.406Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M847.398 95.3999L857.604 105.115L865.096 99.3987L854.212 89.6836L847.398 95.3999V95.3999Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M823.898 161.738L815.68 152.537L783.564 117.365L768.383 104.721L748.959 92.1615L719.021 81.5734L681.252 74.3925L648.259 73.7168L628.299 75.0683L608.792 81.2073L578.401 92.4995L558.442 108.889L532.829 138.288L522.133 161.81"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M754.303 161.754L743.617 149.13L728.436 136.148L710.653 127.277L691.118 123.166L671.583 121.448L643.792 121.786"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M643.792 121.785L616.031 128.628L599.549 137.527L586.515 146.397L574.445 161.796"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M595.697 51.1899L609.811 47.4164L607.775 41.1086L605.74 39.4189"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M605.739 39.4189L592.113 42.8263L594.784 51.1899"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M617.303 36.5474L619.365 44.5448L634.321 42.2639L632.285 33.7031L617.303 36.5474V36.5474Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M643.849 33.1097L644.527 41.6985L660.19 40.544L659.511 32.5465L655.44 31.9834L643.849 33.1097V33.1097Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M670.396 38.8266L686.056 39.9811L686.735 31.9837L671.102 30.8291L670.396 38.8266V38.8266Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M233.439 720.975L246.388 728.972L252.494 722.129L239.574 714.132L233.439 720.975V720.975Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M275.647 744.404L289.274 750.683L294.702 743.248L280.425 736.97L275.647 744.404Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M914.825 946.085L943.408 955.21L948.836 943.214L920.253 934.089L914.825 946.085Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M950.294 895.991L950.221 896.948L959.748 898.104L959.908 895.991"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M970.118 895.989L969.274 902.1L974.702 903.226V910.66L989.008 912.379L991.035 895.989"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M916.182 691.859L959.748 700.982L970.633 663.277L926.388 654.124L916.182 691.859V691.859Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 599.985L1157.81 603.858L1160.81 605.465"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 580.721L1157.11 585.581L1160.81 587.649"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M320.57 758.682L336.232 761.553L338.268 753.556L323.284 750.685L320.57 758.682V758.682Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M369.592 755.247L370.27 763.835L385.932 762.681L385.254 754.684L381.833 754.119L369.592 755.247V755.247Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M395.262 554.551L415.843 568.489L420.706 561.394L400.124 547.427L395.262 554.551Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M415.871 751.248L416.55 759.836L432.212 758.68L431.534 750.683L428.141 750.12L415.871 751.248H415.871Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M475.099 748.968L475.777 757.556L491.44 755.839L490.761 747.842L488.726 747.251L475.099 748.968Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M487.312 234.793L497.547 235.947L498.904 223.36L488.698 222.234L487.313 234.793H487.312Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M505.688 397.052L523.413 400.488L525.449 392.49L507.752 389.055L505.688 397.052Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M503.653 484.461L517.28 485.615L521.351 453.033L526.808 452.47L528.843 453.596L524.772 487.895L538.371 489.613L547.897 418.199L534.978 417.045L532.943 435.884L531.557 438.757L522.708 437.601L525.451 416.482L513.181 415.326L503.653 484.461V484.461Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M774.545 309.643L780.001 316.485L797.699 305.645L791.564 299.364L774.545 309.643V309.643Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M842.621 176.529L851.47 186.808L859.641 182.246L850.792 171.376L842.621 176.529V176.529Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M927.745 869.521L991.722 873.52L993.107 856.961L929.102 852.962L927.745 869.521V869.521Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M959.91 895.99L961.106 880.388L951.578 879.234"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M950.294 895.99L951.578 879.234"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M949.514 369.621L1070.65 437.037L1078.82 426.758L957.656 359.344L949.514 369.621V369.621Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M991.035 895.991L993.108 879.236L972.669 877.518"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M970.118 895.991L972.667 877.518"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M959.72 275.342L969.926 281.058L984.231 261.656L973.318 256.503L959.72 275.342V275.342Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M971.453 413.213L990.988 425.745L995.766 420.48L976.231 407.976L971.453 413.213Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1008.74 783.267L1017.59 783.83L1018.27 764.962L1009.42 764.399L1008.74 783.267Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1009.39 273.652L1056.38 275.343L1057.74 254.222L1010.78 252.505L1009.39 273.652V273.652Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1001.25 312.486L997.83 310.768L988.981 323.355L1004.64 331.352L1014.17 318.765L1009.39 316.485L1020.3 300.489L1012.81 296.49L1001.25 312.486V312.486Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1027.8 325.073L1160.81 398.929"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1027.8 325.073L1020.3 334.196L1160.81 412.228"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1064.21 277.594L1109.33 288.183L1111.73 280.158L1088.3 274.666L1089.37 270.077L1083.09 268.188L1080.92 273.821L1066.81 270.583L1064.21 277.594V277.594Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1119 448.472L1160.81 471.059"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1119 448.472L1110.15 459.905L1160.81 487.259"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 302.347L1157.53 300.462L1160.13 296.887L1151 292.269L1146.9 296.548L1130.62 287.143"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1130.62 287.143L1124.74 293.31L1160.81 313.551"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 513.823L1156.74 517.857L1160.81 520.759"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M522.133 161.812L521.124 164.028L511.145 191.343L505.067 224.825L502.466 252.168L552.816 253.548"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M754.303 161.754L761.851 170.672L777.062 189.793L791.366 203.789L800.498 213.364L822.182 228.063L826.535 230.456L846.947 213.701L858.652 201.396L843.47 183.654L823.898 161.738"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M574.445 161.798L573.935 162.45L564.831 179.881L556.576 210.97L553.098 246.508L552.816 253.547"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 605.466L1199.32 626.132L1221.79 597.579L1235.39 580.428L1218.37 571.305L1193.21 558.155"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 599.985L1166.66 592.424L1165.28 590.143L1160.81 587.648"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1193.21 558.155L1184.36 569.588L1181.62 570.151L1172.77 565.025L1160.81 580.722"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 412.23L1243.56 458.188L1251.05 449.035L1160.81 398.931"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 487.257L1238.13 529.007L1246.98 517.602L1160.81 471.057"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 313.551L1216.98 345.068L1222.64 337.38L1207.66 328.819L1210.48 324.567L1202.23 319.781L1198.33 323.891L1160.81 302.347"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 520.76L1174.95 530.839L1180.12 525.741L1161.91 512.732"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 513.825L1161.91 512.732"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1217.01 882.078L1219.11 890.076L1234.71 887.231L1232 878.671L1217.01 882.078V882.078Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1270.25 376.749L1259.84 367.371L1263.75 363.936L1256.59 358.135L1252.24 361.373L1236.18 348.561L1230.1 353.685L1263.32 382.212L1270.25 376.749V376.749Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1268.75 456.467L1284.41 463.901L1298.72 441.598L1283.05 434.757L1268.75 456.467V456.467Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1299.88 416.538L1320.68 423.69L1323.68 417.551L1302.87 410.371L1299.88 416.538V416.538Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1325.94 688.422L1396.73 712.977L1403.55 698.701L1332.75 674.145L1325.94 688.422V688.422Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1377 491.892L1525.98 574.674"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1377 491.892L1364.05 508.451L1525.98 598.417"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1421.92 708.982L1417.14 712.98V719.259L1421.92 723.257H1429.41L1434.16 719.259L1434.84 714.134L1430.77 709.544L1423.28 708.417L1421.92 708.982V708.982Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1525.98 598.419L1567.6 621.544L1580.52 604.984L1525.98 574.676"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1533.36 440.696L1529.81 446.444L1547.79 457.483L1551.34 451.734L1533.36 440.696V440.696Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1623.38 543.848L1675.82 626.104L1685.32 622.106L1634.94 542.694L1632.23 539.85L1623.38 543.848Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1622.05 591.835L1639.07 619.261L1657.45 611.263L1642.46 586.679L1639.75 583.834L1622.05 591.835V591.835Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1716.08 660.377L1734.03 674.654L1740.48 668.965L1722.53 654.659L1716.08 660.377V660.377Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M720.369 161.763L705.52 151.933L685.88 145.25L661.903 143.13L640.816 145.216L622.399 151.905L607.944 161.02L607.304 161.79"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M746.215 161.757L737.7 149.966L716.634 136.021L691.268 127.388L661.755 124.774L635.064 127.419L611.3 136.05L592 148.223L580.705 161.796"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M312.682 569.155L311.13 574.263L307.834 595.746L310.101 616.706L312.682 624.776"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M312.683 334.565L309.745 334.901L298.101 340.034L285.709 350.175L273.971 365.603L271.622 380.302L273.454 397.66L283.552 414.645L310.605 441.728L312.683 444.46"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M312.682 316.154L302.951 317.274L285.084 325.15L268.639 338.603L252.954 359.223L249.649 379.892L252.058 402.685L265.142 424.681L292.935 452.508L305.917 469.571L311.026 485.172L310.076 502.938L305.052 520.112L289.639 570.825L285.867 595.412L288.519 619.903L295.776 642.597L306.663 659.833L312.682 664.691"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1070.74 895.991L1080.69 910.529L1089.86 918.231L1102.21 921.823L1117.96 922.585L1160.81 915.686"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M804.499 895.991L815.527 900.402L835.102 896.064L835.206 895.991"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1045.58 895.991L1063.16 921.665L1077.91 934.07L1097.91 939.885L1119.42 940.923L1160.81 934.261"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M722.497 164.229H708.982L689.489 168.98L676.23 178.126L668.113 190.962L666.893 212.324L667.608 215.692"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M735.373 182.466H712.098L699.927 185.431L693.51 189.858L689.696 195.89L688.827 211.145L693.427 232.833"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M735.373 182.466L744.637 196.552L760.563 216.151L778.501 231.834L800.487 247.194L1160.81 452.106"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M693.428 232.832L767.737 422.876L782.13 449.958L792.194 466.255L804.089 480.14L826.264 501.558L868.404 528.924L948.81 567.092L976.598 580.121L999.644 596.895L1016.77 618.472L1026.85 645.099L1027.65 668.379L1020.03 692.087L1008.99 713.96L987.764 730.442L952.768 751.258L864.181 789.308L843.693 798.569L821.983 823.768L803.709 861.038L804.192 870.317L809.518 877.776L817.701 881.049L824.811 879.472L838.878 869.638L879.129 825.221L893.257 816.139L924.319 804.416L957.961 802.44L988.507 807.572L1017.27 816.95L1031.9 831.39L1062.59 884.095L1070.74 895.989"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M804.498 895.989L794.133 891.844L782.61 875.7L781.68 857.838L802.759 814.852L828.884 784.52L854.082 773.135L941.405 735.63L973.912 716.294L990.685 703.265L999.319 686.167L1005.73 666.226L1005.11 648.166L996.87 626.416L983.066 609.018L963.931 595.096L937.553 582.727L856.248 544.13L811.144 514.838L786.9 491.425L773.519 475.799L762.416 457.822L747.322 429.423L673.463 240.53"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1045.58 895.99L1043.27 892.623L1013.45 841.416L1004.17 832.258L982.328 825.134L956.556 820.807L929.759 822.378L904.56 831.888L894.773 838.181L854.796 882.294L835.207 895.99"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M900.609 282.075L1160.81 430.049"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M751.293 168.786L763.291 187.031L777.627 204.671L793.432 218.492L813.683 232.641L849.462 252.989"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M722.499 164.229L721.037 162.205L720.368 161.763"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M489.873 370.151L493.702 370.196L514.876 366.121L534.768 356.554L552.31 341.833L566.245 321.045L574.619 299.336L578.833 273.341L583.745 214.141L588.369 191.396L596.616 174.635L607.304 161.79"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M490.586 351.923L491.386 351.931L506.79 348.966L521.332 341.973L534.719 330.734L546.116 313.728L553.234 295.281L557.095 271.469L562.031 211.967L567.245 186.333L577.317 165.866L580.705 161.797"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M746.216 161.756L751.292 168.785"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M489.874 370.15L477.888 370.012"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M478.602 351.78L490.586 351.921"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M312.683 624.774L316.245 635.912L324.359 648.756L339.483 660.958L354.902 667.426L370.05 669.825L451.94 668.364L476.601 665.564L500.306 659.842L514.453 653.278L526.419 643.467L537.01 625.163L548.618 581.893L566.123 489.358L605.035 277.068L613.641 239.033L622.753 224.928L638.584 215.944L653.573 212.979L667.608 215.692"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M312.683 569.155L326.304 524.333L331.799 505.53L332.998 483.127L326.12 462.121L312.683 444.461"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M312.683 334.565L321.913 333.506L336.538 334.954L389.63 357.39L412.603 365.59L440.54 369.58L477.886 370.01"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M312.683 316.154L321.715 315.118L342.938 317.219L398.877 340.86L418.801 347.972L442.545 351.363L478.602 351.78"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M312.683 664.692L326.705 676.012L347.812 684.863L368.229 688.096L453.702 686.574L481.124 683.458L508.753 676.789L527.626 668.035L544.439 654.247L557.766 631.214L570.076 585.329L587.739 491.95L626.572 280.093L634.471 245.203L639.444 237.505L647.53 232.917L653.63 231.713L662.514 233.427L673.463 240.532"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 915.686L1185.97 911.637L1259.33 895.991"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 934.261L1190.66 929.457L1326.97 900.383L1344.55 895.991"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1259.33 895.991L1321.13 882.813L1425.54 856.717L1461.06 844.661L1487.62 832.406L1517.22 810.97L1526.03 802.944"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 452.104L1294.06 527.881L1526 654.493"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1160.81 430.048L1306.14 512.693"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1344.55 895.989L1432.84 873.928L1470.47 861.152L1500.18 847.441L1526.04 828.718"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1526.03 802.943L1573.69 759.517L1600.75 720.924L1605.97 709.106L1602.58 702.347L1590.55 689.732L1526 654.493"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1526.04 828.718L1532.49 824.047L1591.36 770.412L1620.57 728.742L1629.43 708.689L1621.56 692.97L1605.44 676.074L1525.99 632.703"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M1349.96 534.813L1306.14 512.693L1160.81 430.048L992.707 334.449"
          stroke="#73FF31"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1286.45 909.027L1326.97 900.382L1344.55 895.989L1432.84 873.929L1470.47 861.152L1500.18 847.441L1526.04 828.718L1532.49 824.047L1591.36 770.412L1620.57 728.742L1629.43 708.689L1621.56 692.97L1605.44 676.074L1525.99 632.703L1400.37 564.447"
          stroke="#73FF31"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M700.438 309.521L747.323 429.423L762.417 457.822L773.519 475.8L786.9 491.426L811.144 514.838L856.248 544.13L937.553 582.727L963.931 595.096L983.066 609.019L996.87 626.416L1005.11 648.166L1005.73 666.227L999.319 686.167L990.685 703.266L973.912 716.295L941.405 735.63L854.082 773.136L828.884 784.521L802.759 814.852L781.68 857.838L782.61 875.701L794.133 891.845L804.499 895.989L815.527 900.4L835.102 896.062L835.206 895.989H835.207L854.796 882.293L894.773 838.18L904.561 831.887L929.759 822.376L956.556 820.806L982.328 825.133L1004.17 832.257L1013.45 841.415L1043.27 892.622L1045.58 895.989L1063.16 921.663L1077.91 934.068L1097.91 939.883L1119.42 940.921L1160.81 934.259L1190.66 929.455L1286.44 909.025"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M849.463 252.987L813.683 232.639L793.433 218.489L777.627 204.668L763.291 187.029L751.293 168.784H751.291L746.215 161.755L737.699 149.964L716.634 136.019L691.267 127.386L661.754 124.772L635.064 127.417L611.299 136.048L591.999 148.221L580.705 161.795L577.317 165.864L567.244 186.331L562.031 211.965L557.095 271.466L553.234 295.279L546.116 313.726L534.719 330.732L521.332 341.971L506.79 348.963L491.386 351.929L490.586 351.921L478.601 351.78L442.545 351.363L418.8 347.972L398.877 340.86L342.937 317.218L321.714 315.118L312.682 316.154L302.951 317.273L285.084 325.149L268.639 338.603L252.954 359.222L249.649 379.891L252.058 402.684L265.142 424.68L292.935 452.508L305.917 469.57L311.025 485.171L310.076 502.938L305.052 520.111L289.639 570.825L285.867 595.411L288.519 619.903L295.776 642.596L306.663 659.833L312.682 664.69L326.704 676.01L347.811 684.861L368.229 688.094L453.701 686.572L481.123 683.456L508.752 676.787L527.626 668.033L544.438 654.245L557.765 631.212L570.075 585.327L587.738 491.948L626.572 280.091L634.471 245.201L639.444 237.503L647.529 232.915L653.629 231.711L662.513 233.425L673.462 240.53L700.438 309.52"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M992.707 334.449L900.609 282.074"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M720.359 301.704L693.428 232.832L681.229 221.384L667.608 215.691L653.573 212.978L638.584 215.944L622.753 224.927L613.641 239.032L605.035 277.068L566.123 489.358L548.619 581.893L537.011 625.162L526.419 643.467L514.453 653.277L500.306 659.842L476.601 665.564L451.94 668.364L370.05 669.825L354.903 667.425L339.483 660.957L324.358 648.756L316.245 635.911L312.683 624.774L310.101 616.703L307.834 595.744L311.13 574.261L312.683 569.153L326.304 524.331L331.799 505.528L332.998 483.126L326.12 462.12L312.683 444.459L310.605 441.728L283.552 414.644L273.454 397.66L271.622 380.302L273.971 365.602L285.709 350.174L298.1 340.033L309.745 334.9L312.683 334.565L321.913 333.505L336.538 334.953L389.63 357.389L412.603 365.589L440.54 369.579L477.888 370.01L489.875 370.147L489.873 370.149L493.702 370.194L514.876 366.119L534.768 356.552L552.31 341.831L566.245 321.043L574.619 299.334L578.833 273.34L583.745 214.139L588.369 191.394L596.616 174.633L607.304 161.788L607.944 161.018L622.4 151.903L640.816 145.214L661.904 143.128L685.88 145.248L705.52 151.931L720.369 161.761L721.037 162.204L722.5 164.228L735.373 182.464L744.637 196.55L760.563 216.15L778.501 231.832L800.487 247.192L981.958 350.392"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1282.24 891.104L1259.33 895.989L1185.97 911.635L1160.81 915.684L1117.96 922.583L1102.21 921.821L1089.86 918.229L1080.69 910.528L1070.74 895.989L1062.59 884.095L1031.9 831.39L1017.27 816.95L988.508 807.572L957.961 802.44L924.319 804.416L893.257 816.139L879.129 825.221L838.878 869.638L824.811 879.472L817.701 881.048L809.519 877.776L804.192 870.317L803.709 861.038L821.984 823.768L843.693 798.567L864.181 789.308L952.768 751.258L987.764 730.442L1008.99 713.96L1020.03 692.085L1027.65 668.377L1026.85 645.098L1016.77 618.47L999.644 596.893L976.598 580.121L948.81 567.093L868.404 528.924L826.265 501.558L804.089 480.139L792.194 466.253L782.13 449.958L767.737 422.876L720.358 301.704"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M981.958 350.392L1160.81 452.105L1294.06 527.881L1526 654.493L1590.55 689.732L1602.58 702.347L1605.97 709.106L1600.75 720.924L1573.69 759.517L1526.03 802.943L1517.22 810.968L1487.62 832.404L1461.06 844.659L1425.54 856.715L1321.13 882.811L1282.24 891.104"
          stroke="#73FF31"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1400.81 564.702L1389.13 550.828L1363.29 531.928L1243.56 458.186L1174.52 419.843L1137.32 399.179L1020.3 334.195L1004.64 331.351L997.284 327.593"
          stroke="#73FF31"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M993.707 332.914L1000.63 336.833L1015.8 341.352L1349.96 534.812"
          stroke="#73FF31"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M900.59 282.108L962.937 313.049L967.998 313.697L972.625 311.104L981.942 324.895L983.629 327.21L993.707 332.914"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M997.284 327.593L988.982 323.354L979.228 306.169L975.756 304.471L971.843 304.807L966.56 307.721L962.594 307.434L959.676 305.799L892.977 272.263L849.464 252.986"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1521_20374">
        <rect width="1508" height="926" fill="white" transform="translate(233 30)" />
      </clipPath>
      <clipPath id="clip1_1521_20374">
        <rect width="1508" height="926" fill="white" transform="translate(233 30)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面: GPS詳細 サーキットマップ: Auto Police
 */
export default defineComponent({
  name: 'CircuitMapImageAutoPolice',
})
</script>
